export default "__VITE_ASSET__HoOMsRiC__"